import { Fragment, useState, useContext } from 'react';
import { deleteUser, updateUserRole, updateUserDisplay, updateUserPassword } from '../services/userService';
import { Button, Form, Row, Col } from 'react-bootstrap'
import Icons from './common/Icons';
import ProtectedComponent from './common/ProtectedComponent';
import { AuthContext } from './Login/AuthContext';
import DatabaseContext from './DatabaseContext';
import { Navigate } from 'react-router-dom';
import PaginateTable, { CategoryFilter, FuzzyTextFilter } from './common/TableDisplay';

const UserColumns = () => {
  const columns = [
    { Header: 'username', Cell: CellName, Filter: FuzzyTextFilter((user) => [user.username]) },
    { Header: 'display name', Cell: CellDisplay, Filter: FuzzyTextFilter((user) => [user.display_name]) },
    { Header: 'role', Cell: CellRole, Filter: CategoryFilter((user) => user.role) },
  ]
  const { user } = useContext(AuthContext)
  if (user.role === "admin")
    columns.push({ "Header": "password", "accessor": 'id', Cell: CellPassword })
  return columns
}

const CellName = (displayUser) => {
  const { user } = useContext(AuthContext);
  const { updateUserList } = useContext(DatabaseContext);
  const actionDeleteUser = async () => {
    await deleteUser(displayUser.id);
    updateUserList();
  }

  return (
    <Fragment>
      <span>[{displayUser.id}] {displayUser.username}</span>
      {user.role === "admin" &&
        <Button variant="light" onClick={actionDeleteUser} >{Icons.remove}</Button>
      }
    </Fragment>
  );
}

const CellDisplay = (displayUser) => {
  const { updateUserList } = useContext(DatabaseContext);
  const { user } = useContext(AuthContext);
  const isAdmin = user.role === "admin";

  const [editMode, setEditMode] = useState(false);
  const [newUserName, setNewUserName] = useState("");

  const toggleEdit = () => {
    setNewUserName(displayUser.display_name);
    setEditMode(true);
  }
  const editName = async () => {
    await updateUserDisplay(displayUser.id, newUserName);
    updateUserList();
    setEditMode(false);
  }

  return <Row><Col>
    {editMode ? <Form.Control
      text="text"
      value={newUserName} // What to show on first load
      onChange={(e) => setNewUserName(e.target.value)}
      disabled={!isAdmin}
    /> : displayUser.display_name}</Col><Col>
      {isAdmin && (editMode ?
        <Button variant="light" size="sm" onClick={editName}>{Icons.save}</Button> :
        <Button variant="light" size="sm" onClick={toggleEdit}>{Icons.edit}</Button>
      )}
    </Col></Row>
}

const CellRole = (displayUser) => {
  const { updateUserList } = useContext(DatabaseContext);
  const { user } = useContext(AuthContext);
  const isAdmin = user.role === "admin";

  const [editMode, setEditMode] = useState(false);
  const [selectRole, setSelectRole] = useState(displayUser.role)

  const toggleEdit = () => {
    setSelectRole(displayUser.role);
    setEditMode(true);
  }

  const editRole = async () => {
    await updateUserRole(displayUser.id, selectRole);
    updateUserList();
    setEditMode(false);
  }

  return <Row>
    <Col>
      {editMode ? <Form.Select
        id="roleselect_user"
        value={selectRole}
        disabled={!isAdmin}
        onChange={(e) => { setSelectRole(e.target.value) }}
      >
        <option value="admin">admin</option>
        <option value="user">user</option>
        <option value="public">public</option>
      </Form.Select> :
        displayUser.role
      }
    </Col>
    <Col>
      {isAdmin && (editMode ?
        <Button variant="light" size="sm" onClick={editRole}>{Icons.save}</Button> :
        <Button variant="light" size="sm" onClick={toggleEdit}>{Icons.edit}</Button>
      )}
    </Col>
  </Row>
}

const CellPassword = (user) => {
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);

  const editPassword = async () => {
    await updateUserPassword(user.id, password);
    setPassword("");
  }
  return <Fragment>
    <Row>
      <Col>
        <Form.Control type={showPass ? "text" : "password"} placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} />
      </Col><Col>
        <Col sm={1}><p onClick={() => setShowPass(!showPass)} style={{ color: "gray", textDecoration: "underline" }}>{showPass ? "Hide" : "Show"}</p></Col >
      </Col><Col>
        <Button variant="light" size="sm" onClick={editPassword}>{Icons.save}</Button>
      </Col>
    </Row>
  </Fragment>
}

export const UserList = () => {
  const { user } = useContext(AuthContext);
  const { userList } = useContext(DatabaseContext);
  if (user) {// Additional item that can be missed by the ProtectedComponent, as the userList is read only
    return <ProtectedComponent>
      <PaginateTable tableData={userList} columnLayout={UserColumns()} entriesPerPage={20} />
    </ProtectedComponent >;
  } else {
    return <Navigate to="/login" />
  }
}

export default UserList;
